<div class="welcome">
  <div class="welcome-header">
    @if (user) {
      <h1>Welcome, {{ user.username }}!</h1>
    }
    <div>
      Let's start your journey. Choose one of the options below, to get started
    </div>
    <div class="separator"></div>
  </div>
  <div class="welcome-content">
    <div class="welcome-pane">
      <h3>{{ "welcome-screen.title.onboarding" | translate }}</h3>
      @if (onboardings) {
        <div class="onboardings">
          @for (item of onboardings; track item) {
            <div class="onboarding-item">
              @if (item && item.imagePath) {
                <img [src]="item.imagePath" />
              }
              <div class="item-content">
                <div class="type">{{ item.type }}</div>
                <div class="title">{{ item.title }}</div>
                @if (item.demoTime) {
                  <div class="demo-time">
                    <fa-icon [icon]="item.demoTime.icon"></fa-icon>
                    <div>{{ item.demoTime.time }}</div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      <h3>{{ "welcome-screen.title.get-started" | translate }}</h3>
      @if (onboardings) {
        <div class="onboardings">
          @for (item of getStarted; track item) {
            <div class="onboarding-item">
              @if (item && item.imagePath) {
                <img [src]="item.imagePath" />
              }
              <div class="item-content">
                <div class="type">{{ item.type }}</div>
                <div class="title">{{ item.title }}</div>
                @if (item.demoTime) {
                  <div class="demo-time">
                    <fa-icon [icon]="item.demoTime.icon"></fa-icon>
                    <div>{{ item.demoTime.time }}</div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="welcome-pane">
      <img src="./assets/img/intro/illustration.png" />
    </div>
  </div>
</div>
